import { Schema } from 'effect';

import { StringRequired } from '../primitive/string';

const formNameOptionLiteral = Schema.Union([
  Schema.Literal('Newsletter'),
  Schema.Literal('Contact'),
]);

export const GtmFormSubmittedEventSchema = Schema.Struct({
  event: Schema.Literal('form_submitted'),
  form_name: formNameOptionLiteral,
  form_email: StringRequired,
}).annotate({ identifier: 'GtmFormSubmittedEventSchema' });

export type GtmFormType = Schema.Schema.Type<typeof formNameOptionLiteral>;
export type GtmFormSubmittedEvent = Schema.Schema.Type<typeof GtmFormSubmittedEventSchema>;
